<script>

	import Input from './Input'
	import Select from './Select'
	import { validationMixin } from 'vuelidate'

	const Form = {
		mixins: [ validationMixin ],
		provide () {
			return {
				Form: this
			}
		},
		props: {
			formData: {
				type: Object
			},
			schema: {
				type: Object,
				required: true
			},
			action: {
				type: String
			}
		},
		data () {
			return {
				loading: false,
				success: false
			}
		},
		methods: {
			async submitHandler (e) {
				if(!this.action) {
					e.preventDefault()
					const { submit } = this.$listeners
					if(submit) {
						try {
							this.success = false
							this.loading = true
							await submit(this)
							this.success = true
						} catch (err) {
							alert('There was an error while processing your request. Please refresh the page and try again.')
						} finally {
							this.loading = false
						}
					}
				}
			}
		},
		validations () {
			return {
				formData: this.schema
			}
		},
		render () {
			return (
				<form action={this.action} class="form" onSubmit={this.submitHandler}>
					{this.$scopedSlots.default(this)}
					{!this.success && (
						<div class="form__submit">
							<btn>
								<input
									type="submit"
									value={(this.loading) ? 'Sending...' : 'Submit'}
									disabled={this.loading || this.$v.formData.$invalid}
								/>
							</btn>
						</div>
					)}
				</form>
			)
		}
	}

	Form.Input = Input
	Form.Select = Select

	export default Form

</script>

<style lang="scss">

	@import "form-styles";

	.form {
		@include form-styles;
	}

</style>



// WEBPACK FOOTER //
// src/components/Form/index.vue